import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-sortir'
})
export class SortirComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    /*this.activatedRoute.queryParams.subscribe(params => {
      const urlDest = params['urlDest'];

      if(urlDest) window.location.href = urlDest;
    });*/
  }

  ngOnInit() {
  }

}
